import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { mobile } from '../utils';

export class UcParentLink extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        max-height: ${pxToRem(25)};
      }

      .link {
        --button-color: #57ad31;
        --button-hover-color: #4ba842;

        display: flex;
        align-items: center;
      }

      ::slotted(a) {
        display: flex;
        flex: none;
        align-items: center;
        justify-content: stretch;
        text-decoration: none;
      }

      .link::before,
      .link::after {
        display: flex;
        flex: 1 1 25%;
        max-width: 100%;
        height: 1px;

        background-color: #d9d9d9;
      }

      .link::before {
        content: '';
      }

      .link::before {
        margin-right: ${pxToRem(8)};
      }

      .link::after {
        margin-left: ${pxToRem(8)};
      }

      ${mobile(css`
        .link::after {
          content: '';
        }
      `)}
    `;
  }

  render() {
    return html` <uc-button class="link" buttonstyle="base"><slot></slot></uc-button> `;
  }
}
